import styled, { css } from 'styled-components';
import { ReactComponent as timeSvg } from 'common/assets/icons/domain-specific/Analytics/clock.svg';
import { ReactComponent as polygonSvg } from 'common/assets/icons/domain-specific/Analytics/polygon.svg';
import { ifProp } from 'styled-tools';

export const OrderListItem = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 38px 14px;
  box-shadow: 0 20px 40px 0 rgba(25, 25, 46, 0.05);
  background: #fff;
  cursor: pointer;
  ${ifProp(
    'isActive',
    css`
      border: 2px solid #2d9cdb;
    `
  )}

  & > section,
  div {
    width: 25%;
  }
`;

export const OrderListWrapper = styled.div`
  position: relative;
  max-width: 750px;
  height: 480px;
  overflow-y: auto;
  width: 100%;
  padding-right: 9px;
  ${OrderListItem} + ${OrderListItem} {
    margin-top: 13px;
  }
`;

export const Symbol = styled.section`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #2f2f2f;
`;

export const Price = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #7d7d7d;
`;

export const Arrow = styled(polygonSvg)``;

export const OrderParam = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: rgba(58, 191, 87, 1);

  ${ifProp(
    'red',
    css`
      color: #f6543e;

      ${Arrow} {
        stroke: #f6543e;
        transform: rotate(180deg);

        path {
          fill: #f6543e;
        }
      }
    `
  )}
`;

export const Profit = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: ${ifProp('red', '#f6543e', 'rgba(58, 191, 87, 1)')};
`;

export const Time = styled(timeSvg)`
  ${ifProp(
    'red',
    css`
      path {
        fill: #f6543e;
      }
    `
  )}
`;

export const MobileTitle = styled.h1`
  display: none;
  font-weight: normal;
  font-size: 36px;
  line-height: 150%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3f4047;

  @media (max-width: 600px) {
    display: block;
  }
`;

export const MobileText = styled.p`
  display: none;
  margin: 25px 0;
  font-weight: normal;
  font-size: 18px;
  line-height: 170%;
  text-align: center;
  letter-spacing: 0.04em;
  color: #3f4047;

  @media (max-width: 600px) {
    display: block;
  }
`;
